import React, { useContext } from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import toSeoUrl from "@functions/toSeoUrl";
import { ApplicationContext } from "@context/ApplicationContext";
import { UserContext } from "@context/UserContext";
import PlayIcon from "@components/Icons/PlayIcon";
import TrailerButton from "@components/TrailerButton";
import V3SessionButton from "@components/V3/V3SessionButton";
import { getSessionType } from "@utils/ticketUtils";
import "./style.scss";

const VenueSessionList = ({ selectedDate, sessions }) => {
    const { cdnUrl } = useContext(ApplicationContext);
    const { promoDetails } = useContext(UserContext);
    const promoTicketClasses = promoDetails?.promoTicketClasses || [];

    const fallbackImage = `${cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;

    const onImageError = (e) => {
        e.target.src = fallbackImage;
    };

    if (Object.keys(sessions).length < 1) {
        return (
            <div className="sessions-available__message">
                <p className="sessions-available__message-title">
                    Sorry, we couldn&apos;t find any results for your chosen cinema
                </p>
                <p className="sessions-available__message-text">
                    Please select a different cinema to find sessions.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="sessions-list__movies">
                <div className="sessions-list__movies-list">
                    {Object.entries(sessions).map(([movie, sessions]) => {
                        const first = sessions[0];

                        return (
                            <div className="sessions-list__movies-item-wrapper" key={first.movie_id} >
                                <div className="sessions-list__movies-item" >
                                    <Link
                                        className="sessions-list__movies-link"
                                        to={`/movie/${first.movie_id}/${toSeoUrl(first.movie_title)}`}
                                    >
                                        <img
                                            className="sessions-list__movies-image"
                                            src={first.movie_image || fallbackImage}
                                            alt={first.movie_title}
                                            onError={onImageError}
                                        />
                                    </Link>
                                    <div className="sessions-list__movies-content">
                                        <Link
                                            className="sessions-list__movies-title"
                                            to={`/movie/${first.movie_id}/${toSeoUrl(first.movie_title)}`}
                                        >
                                            {first.movie_title}
                                        </Link>
                                        <ul className="sessions-list__movies-meta">
                                            {first.movie_rating ? (
                                                <li className="sessions-list__movies-meta-item">{first.movie_rating}</li>
                                            ): null}

                                            {first.movie_run_time ? (
                                                <li className="sessions-list__movies-meta-item">{first.movie_run_time}mins</li>
                                            ): null}

                                            {first.movie_genre ? (
                                                <li className="sessions-list__movies-meta-item">{first.movie_genre}</li>
                                            ): null}

                                        </ul>
                                        <p className="sessions-list__movies-description">{first.movie_blurb}</p>
                                        {first.trailer_url ? (
                                            <TrailerButton
                                                extraClass="sessions-list__movies-trailer"
                                                type="mp4"
                                                trailerLink={first.trailer_url}
                                            >
                                                <PlayIcon className="sessions-list__movies-icon-svg" />
                                                <span className="sessions-list__movies-trailer-text">
                                                    Official Trailer
                                                </span>
                                            </TrailerButton>
                                        ) : null}
                                    </div>
                                </div>
                                <h3 className="sessions-list__sessions-available-date">
                                    {selectedDate
                                        ? format(
                                            new Date(selectedDate),
                                            "EEE d MMM",
                                        )
                                        : null}
                                </h3>
                                <div className="sessions-list__sessions-available-list">
                                    {sessions.map((session) => {
                                        const experience_type = getSessionType(session);
                                        const showPromoIcon = promoTicketClasses.includes(Number(session?.ticket_class_id));
                                        return (
                                            <V3SessionButton
                                                key={session.id}
                                                session={{ ...session, experience_type }}
                                                showPromoIcon={showPromoIcon}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default VenueSessionList;
